<div class="mat-toolbar-footer-container">
  <div class="line"></div>
  <div class="toolbar">
    <div class="version-content">
      {{ version }}
    </div>
  </div>
</div>
